<template>

  <div class="row mx-0">

    <b-card class="col-9">
    

      <!-- <hr> -->

      <b-row class="d-flex align-items-center">

        <SearchOpts
          v-model="filtersTemp.paciente"
          :searchService="pacientesService.searchPacientesByTermSelect"
          :placeholder="'Buscar por nombre o cedula el paciente...'"
          class="col-6"
        />


        <SearchOpts
          v-if="isAuditor"
          v-model="filtersTemp.doctor"
          :searchService="doctoresService.searchDoctoresByTermSelect"
          :placeholder="'Buscar atenciones por doctor...'"
          class="col-6"
        />

        <!-- <b-form-input 
          v-model="consultarlab"
          placeholder="Buscar por cedula, nombre, apellido paciente o doctor" type="text"
          class="d-inline-block col-md-6" 
        /> -->

        
      <!-- <v-select 
        id="establecimiento" 
        v-model="filters.establecimiento" 
        :options="establecimientosOpts"
        placeholder="Establecimiento" 
        :reduce="option => option.value"
        label="text"
        class="col-3" 
      /> -->

        <v-select 
          id="especialidad" 
          v-model="filtersTemp.especialidad" 
          :options="especialidadesOpts"
          placeholder="Especialidad" 
          :reduce="option => option.value" 
          label="text"
          :class="isXima ? 'col-3 mt-1' : 'col-3 mt-1'" 
        />

        <v-select
          v-if="isXima"
          id="establecimiento"
          v-model="filtersTemp.establecimiento"
          :options="establecimientosOpts"
          placeholder="Establecimiento"
          :reduce="option => option.value"
          label="text"
          class="col-3 mt-1"
        />

        <!-- <v-select 
          id="segsalud" 
          v-model="filtersTemp.segsalud" 
          :options="segsOpts"
          placeholder="Seguro Salud" 
          :reduce="option => option.value" 
          label="text"
          class="col-3 mt-1" 
        /> -->

        <v-select 
          v-model="filtersTemp.estadoRevision" 
          :options="estadoAtencionOpts" 
          placeholder="Estado Revision"
          :reduce="option => option.value" 
          label="text" 
          class="col-3 mt-1" 
        />

        <b-col md="3" class="mt-1">
          <flat-pickr 
            v-model="filtersTemp.fechaDesde" 
            placeholder="Fecha(desde):" 
            class="form-control" 
          />
        </b-col>

        <b-col md="3" class="mt-1">
          <flat-pickr 
            v-model="filtersTemp.fechaHasta" 
            placeholder="Fecha(hasta):" 
            class="form-control" 
          />
        </b-col>

        

        <!-- <b-form-checkbox
          class="col-2 mt-1"
          id="sindiag"
          v-model="filters.sinDiagnosticos"
          name="sindiag"
          value="1"
          switch
        >
          Sin diagnosticos
        </b-form-checkbox> -->

        <v-select 
          id="cobertura" 
          v-model="filtersTemp.cobertura" 
          :options="coberturaOpts"
          placeholder="Buscar por cobertura." 
          :reduce="option => option.value" 
          label="text" 
          class="col-3 mt-1" 
        />


        <b-col 
          md="3" 
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
        > 
          <label>ID: </label> 
          <b-form-input  
            class="ml-1"        
            v-model="idAtencion"
          />  

          <b-button 
            v-if="idAtencion" 
            class="ml-1" 
            variant="primary" 
            size="sm" 
            @click="buscarId()"
          >
            Buscar por ID
          </b-button>
        </b-col>


        <b-button
          variant="primary"
          class="col-2 mt-1"
          @click="onSetFilters"
        >
          Buscar
        </b-button>

        <b-button 
          class="ml-1 mt-1" 
          variant="warning" 
          @click="onClearFilters"
          title="Limpiar filtros"
        >
          <i class="fa-solid fa-eraser"/>
        </b-button>

      </b-row>
    </b-card>

    <FilterObservaciones class="col-2" style="border: 1px solid #c9c9c9"/>

  </div> 
  
</template>

<script>

import vSelect from 'vue-select';
import { doctoresService } from "@/shared/services";
import { pacientesService } from "@/views/admision/services";
import { establecimientosService, especialidadesService } from "@/views/administracion/services";
import { SearchOpts } from '@/shared/components';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { comprobarRoles, getEstablecimientoLS } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import { mapState } from 'vuex';
import ReportesAtenciones from './ReportesAtenciones.vue';
import FilterObservaciones from '../FilterObservaciones/FilterObservaciones.vue';

export default {
  name: 'FiltersTableAtenciones',

  components: {
    SearchOpts,
    vSelect,
    flatPickr,
    ReportesAtenciones,

    FilterObservaciones
  },


  data(){
    return {

      doctoresService,
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),

      filtersTemp:{
        segsalud:null,
        paciente:null,
        doctor  : null,
        especialidad: null,
        establecimiento: null,
        estadoRevision:null,
        fechaDesde: null,
        fechaHasta: null,
        excelImc: null,
        porRevisar:null,
        cobertura:null,
        idAtencion : null
      },

      filters:{
        segsalud:null,
        paciente:null,
        doctor  : null,
        especialidad: null,
        establecimiento: null,
        estadoRevision:null,
        fechaDesde: null,
        fechaHasta: null,
        // establecimiento: null,
        excelImc: null,
        sinDiagnosticos: null,
        porRevisar:null,
        idAtencion : null
      },

      idAtencion : null,

      especialidadesOpts: [],
      establecimientosOpts: [],
      pacientesService,

      estadoAtencionOpts: [
        { value: '0', text: 'Atendida' },
        { value: '1', text: 'Por revisar' },
        { value: '2', text: 'Revisada' },
        { value: '3', text: 'Concluida' }, 
        { value: '4', text: 'Anulada' },  
        { value: '5', text: 'Auditada' } 
      ],

      coberturaOpts: [
        { value: '1', text: 'IESS' },
        { value: '2', text: 'ISSPOL' },
        { value: '3', text: 'ISSFA' },
        { value: '5', text: 'PARTICULAR' }, 
        { value: '6', text: 'PRIVADO' },  
        
      ],
    }
  },



  created(){
    this.loadInitData();
    this.loadFiltersLS();
  },


  methods:{

    loadFiltersLS(){
      const dataFilters = JSON.parse(localStorage.getItem('filterAtenciones'));
      if(dataFilters) this.filtersTemp = dataFilters;
      this.onSetFilters();
    },

    onSetFilters(){
      this.filters = { 
        ...this.filtersTemp,
      };
    },

    onClearFilters(){
      this.filtersTemp = {
        segsalud       : null,
        paciente       : null,
        doctor         : null,
        especialidad   : null,
        estadoRevision : null,
        fechaDesde     : null,
        fechaHasta     : null,
        excelImc       : null,
        porRevisar     : null,
        idAtencion     : null,
        establecimiento: null,
      }

      this.$store.commit("setFilterAtencionesObservaciones", null);

      this.onSetFilters();
    },

    buscarId(){
      this.filters.idAtencion = this.idAtencion
    },

    descargarImcExcel(){
      this.filters.excelImc = '1'
      setTimeout(() => {
        this.filters.excelImc = '';
      }, 1000);

    },

    descargarExcelRevisiones(){
      this.filters.excelImc = '2'
      setTimeout(() => {
        this.filters.excelImc = '';
      }, 1000);

    },
    
    async loadInitData(){
      this.establecimientosOpts = await establecimientosService.getForSelect();
      this.especialidadesOpts = await especialidadesService.getOptionsSelect();
    },


    onClickSearch(){
      this.$store.commit("setFilterAtenciones", this.filters);
    }
  },


  computed: {

    ...mapState({
      stFilterAtencionesObservaciones: state => state.generals.filterAtenciones.observaciones,
    }),

    isAuditor(){
      return comprobarRoles( [ROLES.AUDITOR, ROLES.JEFE_AUDITOR] );
    },
    isXima(){
      const est = getEstablecimientoLS && getEstablecimientoLS();
      return est?.uniCodigo === '36451';
    }
  },

  watch:{

    filters: {
      deep:true,
      handler(){
        if(!this.filters) return;

        const newFilters = { 
          ...this.filters,
          observaciones: this.stFilterAtencionesObservaciones,
        };

        localStorage.setItem('filterAtenciones', JSON.stringify(newFilters));
        this.$store.commit("setFilterAtenciones", newFilters);
      }
    },


  }
}
</script>
